export const SITE_ID_SIERRA = '698d23639742c79b2f8cb1f1';
export const SITE_ID_PRIDE_CHEMICALS = '698d239b9742c79b2f8cb1f2';
